import {Progress} from "antd";
import React from "react";
export const FullProgress = ({startColor = "#FF0000", endColor = "#d6ff01", progress = 0}) => {
    const translateColorByProgress = progress => {
        //smooth transition between colors
        const startColor = [255, 0, 0];
        const endColor = [214, 255, 1];
        const r = Math.floor(startColor[0] + (endColor[0] - startColor[0]) * progress * 0.01);
        const g = Math.floor(startColor[1] + (endColor[1] - startColor[1]) * progress * 0.01);
        const b = Math.floor(startColor[2] + (endColor[2] - startColor[2]) * progress * 0.01);
        return `rgb(${r},${g},${b},${progress * 0.01})
    `;
    };

    return (
        <Progress
            className="full-progress"
            strokeLinecap="square"
            type="line"
            width={100}
            percent={progress}
            showInfo={false}
            strokeColor={translateColorByProgress(progress)}
        />
    );
};
